import React from "react";
import Styles from "./TextInput.module.css";
import { IconButton, Tooltip } from "@mui/material";
import { ReactComponent as InfoIcon } from "../../../assets/images/info.svg";

const TextInput = ({
  heading,
  isInteger,
  example,
  value,
  onChange,
  readOnly = false,
  type = "text",
  height = 40,
  error,
  gap = 8,
  disabled = false,
  info,
  width,
  inputStyle,
  min,
  max,
}) => {
  return (
    <div
      className={Styles.inputTextContainer}
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        gap: `${gap}px`,
      }}
    >
      {heading || info ? (
        <div className={Styles.inputLabelContainer}>
          {heading && <div className={Styles.inputLabel}>{heading}</div>}{" "}
          {info && (
            <Tooltip
              title={
                <span style={{ whiteSpace: "pre-line" }}>{info}</span> || ""
              }
            >
              <IconButton>
                <InfoIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      ) : null}

      <div
        className={Styles.inputContainer}
        style={{
          height: `${height}px`,
          width: width ? width : "100%",
          backgroundColor: disabled ? "#e9e9e9" : "white",
        }}
      >
        <input
          {...(min !== undefined ? { min } : {})}
          {...(max !== undefined ? { max } : {})}
          style={inputStyle}
          disabled={disabled}
          type={type}
          className={Styles.textInput}
          placeholder={example}
          value={value}
          onChange={(e) => {
            let val = e.target.value;
            if (type === "number" && !isInteger) {
              if (val === "" || /^\d*\.?\d{0,2}$/.test(val)) {
                onChange(val);
              }
            } else if (type === "number" && isInteger) {
              if (val === "" || /^\d*$/.test(val)) {
                onChange(val);
              }
            } else {
              onChange(val);
            }
          }}
          readOnly={readOnly}
        />
      </div>
      {error && (
        <div
          className={Styles.errorHeading}
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            fontSize: "10px",

            marginTop: "2px",
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default TextInput;
